import { Center, Loader } from '@mantine/core';
import { useEffect, useState } from 'react';
import { Navigate } from 'react-router';
import { getSupabaseBrowserClient } from '@/lib/supabase/browser';

/**
 * Root route (/) — no marketing page, just a redirect gate.
 *
 * Matches the behaviour of the old Next.js middleware.ts:
 *  - Authenticated users are sent to /interview
 *  - Unauthenticated users are sent to /auth/login
 *
 * Shows a loader while we check the session to avoid a flash of
 * the wrong destination.
 */
export function RootRedirect() {
  const [state, setState] = useState<'loading' | 'auth' | 'anon'>('loading');

  useEffect(() => {
    const supabase = getSupabaseBrowserClient();
    let cancelled = false;

    supabase.auth.getUser().then(({ data, error }) => {
      if (cancelled) return;
      setState(error || !data.user ? 'anon' : 'auth');
    });

    return () => {
      cancelled = true;
    };
  }, []);

  if (state === 'loading') {
    return (
      <Center h="100vh">
        <Loader size="lg" />
      </Center>
    );
  }

  if (state === 'auth') {
    return <Navigate to="/interview" replace />;
  }

  return <Navigate to="/auth/login" replace />;
}
